export default __webpack_public_path__ + "static/media/guido-gaviglio-1.7db040e4.webp";